import { getCookieValue } from '../../util/helper';

export default function () {
    const body = document.getElementsByTagName('BODY')[0];
    const announcement = document.getElementById('c-alert');
    const announcementClose = document.getElementById('close-alert');
    const cookieName = 'closedMsg-' + announcement?.dataset?.name || 'not-active';

    function setCookie(name, value, days) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    function getCookie(name) {
        var consent = getCookieValue(name);
        return consent;
    }

    function showAnnouncement() {
        if (announcement != null) {
			const dismissed = getCookie(cookieName);
			if (dismissed === '' || !dismissed || dismissed === 'false') {
                body.classList.add('show-alert');
            }
        }
    }

    function closeAnnouncement() {
        body.classList.remove('show-alert');
        setCookie(cookieName, true, 7);
    }

    if (announcementClose != null) {
        announcementClose.addEventListener('click', e => {
            closeAnnouncement();
        });
    }

    showAnnouncement();
}
